import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { darkTheme } from '@stylesheets/theme';
import Button, {
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_OUTLINE,
} from '@components/1-atoms/Button';
import { useSignupConfig } from '@hooks/useSignupConfig';
import { STORAGE_KEYS } from '@constants/index';
import {
  Wrapper,
  Background,
  Header,
  Logo,
  BrandName,
  Content,
  Badge,
  Headline,
  HighlightText,
  Subtitle,
  SubtitleSecondary,
  ButtonGroup,
} from './Landing.styled';

const CHAT_INPUT_PARAM = 'chat-interface__input';

const Landing: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { signupBlocked } = useSignupConfig();

  useEffect(() => {
    const pendingInput = searchParams.get(CHAT_INPUT_PARAM);
    if (pendingInput) {
      localStorage.setItem(STORAGE_KEYS.PENDING_CHAT_INPUT, pendingInput);
    } else {
      localStorage.removeItem(STORAGE_KEYS.PENDING_CHAT_INPUT);
    }
  }, [searchParams]);

  return (
    <ThemeProvider theme={darkTheme}>
      <Wrapper>
        <Background />
        <Header>
          <Logo />
          <BrandName>Aibuild OS</BrandName>
        </Header>
        <Content>
          <Badge>Now in public beta</Badge>
          <Headline>
            The AI Operating System for{' '}
            <HighlightText>Engineering Workflows</HighlightText>
          </Headline>
          <Subtitle>
            Design, simulate, and manufacture faster with AI-powered
            CAD/CAE/CAM automation. One platform for your entire engineering
            pipeline.
          </Subtitle>
          <SubtitleSecondary>
            {signupBlocked
              ? 'Sign in to continue'
              : 'Sign in or create an account to continue'}
          </SubtitleSecondary>
          <ButtonGroup>
            {!signupBlocked && (
              <Button
                variant={BUTTON_VARIANT_PRIMARY}
                onClick={() => navigate('/auth/signup')}
                stretch={false}
              >
                Create account
              </Button>
            )}
            <Button
              variant={signupBlocked ? BUTTON_VARIANT_PRIMARY : BUTTON_VARIANT_OUTLINE}
              onClick={() => navigate('/auth/login')}
              stretch={false}
            >
              Log in
            </Button>
          </ButtonGroup>
        </Content>
      </Wrapper>
    </ThemeProvider>
  );
};

export default Landing;
